import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
type Plan = {
  name: string;
  tagline: string;
  features: string[];
  featured?: boolean;
  cta: string;
};
const plans: Plan[] = [{
  name: 'Landing Express',
  tagline: 'Ideal para empezar a vender ya mismo.',
  features: ['1 página', 'Botón de WhatsApp', 'Formulario de contacto', 'Dominio propio', 'Entrega 24 hs'],
  cta: 'Quiero esta'
}, {
  name: 'Web Profesional',
  tagline: 'La elección de la mayoría de los negocios.',
  features: ['Hasta 5 secciones', 'Galería de fotos', 'Mapa de ubicación', 'SEO básico', 'Dominio propio', 'Entrega 24 hs'],
  featured: true,
  cta: 'Quiero esta'
}, {
  name: 'Web Premium',
  tagline: 'Para negocios que quieren mostrarlo todo.',
  features: ['Secciones ilimitadas', 'Catálogo de productos o servicios', 'Blog o novedades', 'SEO avanzado en Google', 'WhatsApp y formularios', 'Dominio propio', 'Entrega 24 hs'],
  cta: 'Quiero esta'
}];
export function Pricing() {
  return <section id="planes" className="w-full bg-white py-20 sm:py-28" data-id="element-143" data-mp="9siak3o6wr3s">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-144" data-mp="9qe69kmdpq2z">
        <SectionHeading eyebrow="Planes" title="Elegí el plan de tu negocio" description="Precio claro desde el primer mensaje. Todos los planes se entregan en 24 horas." data-id="element-145" data-mp="eq0l1yhuvedw" />

        <div className="mt-14 grid items-start gap-6 lg:grid-cols-3" data-id="element-146" data-mp="3i8jzny7m2lq8">
          {plans.map((plan, index) => <motion.article key={plan.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: index * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} className={['relative flex h-full flex-col rounded-3xl bg-white p-8', plan.featured ? 'border-2 border-brand-yellow shadow-lift lg:-mt-4 lg:pb-10 lg:pt-12' : 'border border-black/5 shadow-soft'].join(' ')} data-id="element-147" data-mp="3n5240wz14i21" data-mpi={index}>
              {plan.featured && <span className="absolute -top-3 left-8 rounded-full bg-brand-yellow px-4 py-1 text-[11px] font-extrabold uppercase tracking-wide text-brand-ink" data-id="element-148" data-mp="2w8mhv06s2ts9">
                  Más elegido
                </span>}

              <h3 className="text-xl font-extrabold uppercase tracking-tight" data-id="element-149" data-mp="23kqlxxp195wj">{plan.name}</h3>
              <p className="mt-2 text-sm text-brand-ink/55" data-id="element-150" data-mp="2ihrdo17850v0">{plan.tagline}</p>

              <ul className="mt-7 flex-1 space-y-3" data-id="element-151" data-mp="2dg27ayuy5bd9">
                {plan.features.map(feature => <li key={feature} className="flex items-start gap-3 text-sm font-medium text-brand-ink/80" data-id="element-152" data-mp="3tu0krnizcmtc">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-yellow" data-id="element-153" data-mp="3ovqu9q87aae2">
                      <CheckIcon className="h-3 w-3 text-brand-ink" aria-hidden="true" data-id="element-154" data-mp="cq9xnjc545k" />
                    </span>
                    {feature}
                  </li>)}
              </ul>

              <a href="#contacto" className={['mt-8 inline-flex w-full items-center justify-center rounded-full px-6 py-3.5 text-sm font-bold transition-transform hover:-translate-y-0.5', plan.featured ? 'bg-brand-yellow text-brand-ink shadow-soft' : 'border border-black/10 bg-white text-brand-ink hover:bg-black/[0.03]'].join(' ')} data-id="element-155" data-mp="3rgor30z11kh7">
                {plan.cta}
              </a>
            </motion.article>)}
        </div>
      </div>
    </section>;
}